import { useState, useEffect } from "react";
import { getProfessionals } from "../api/user";

export function useProfessionalsDropdown() {
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        // getProfessionals espera { queryKey: [key, params] } (uso normal via react-query,
        // ver Professionals.js) - llamado como getProfessionals(null, {}) esto lanzaba
        // "Cannot destructure property 'queryKey' of 'null'" y el catch de abajo lo
        // tragaba, dejando este dropdown siempre vacio para administrativo/administrador.
        // limit alto (no hay modo "sin paginar" en el backend) para traer todos los
        // profesionales del centro medico, no solo los primeros 10.
        const response = await getProfessionals({
          queryKey: ['professionals', { start: 1, paginatedSize: 1000, firstname: '', lastname: '', dni: '' }]
        });
        const profesionalesArray = (response?.results || [])
            .sort((a, b) => {
                const nameA = `${a.lastname || ''} ${a.firstname || ''}`.toLowerCase();
                const nameB = `${b.lastname || ''} ${b.firstname || ''}`.toLowerCase();
                return nameA.localeCompare(nameB, 'es');
            });
        setProfessionals(profesionalesArray);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { professionals, loading, error };
}
